module.exports = __webpack_public_path__ + "static/media/contents_manabi.c04dcdc9.png";